<app-modal-view
  modalTitle="Vehicle Lookup"
  role="dialog"
  [disableClickOut]="true"
  data-testid="vehicle-lookup-modal"
>
  <section modal-body>

    <div class="tool-bar">
      <app-search-form [placeholder]="'Search'" data-testid="vehicle-lookup-search"></app-search-form>
      <button
        mat-button
        data-testid="vehicle-lookup-single-toggle-btn"
        (click)="getSingleVehiclePanelOpen=!getSingleVehiclePanelOpen;getAllVehiclesPanelOpen=false;getInventoryVin='';"
      >
        Get Single Vehicle
      </button>
      <button
        mat-button
        data-testid="vehicle-lookup-all-toggle-btn"
        (click)="getAllVehiclesPanelOpen=!getAllVehiclesPanelOpen;getSingleVehiclePanelOpen=false;getInventoryVin='';"
      >Get
        All Vehicles
      </button>
      <button mat-button data-testid="vehicle-lookup-refresh-btn" (click)="refreshVehicleList()">Refresh List</button>
    </div>

    <div class="tool-panel" *ngIf="getSingleVehiclePanelOpen">
      <h2>Get Single Vehicle</h2>
      <p>Loading a single vehicle typically takes less then 15 seconds.</p>
      <div class="sub-tools">
        <input
          placeholder="Enter VIN"
          data-testid="vehicle-lookup-vin-input"
          [ngModel]="getInventoryVin"
          (ngModelChange)="updateGetInventoryVin($event)"
        >
        <button
          mat-button
          data-testid="vehicle-lookup-single-submit-btn"
          (click)="getInventoryForVin()"
          [disabled]="!getInventoryVin"
        >
          Get Single Vehicle
        </button>
      </div>
    </div>

    <div class="tool-panel" *ngIf="getAllVehiclesPanelOpen">
      <h2>Get All Vehicles</h2>
      <p>Retrieving all inventory may take up to 1 hour and will run in the background. You can click the refresh list
        button to update the list.</p>
      <div class="sub-tools">
        <button mat-button data-testid="vehicle-lookup-all-submit-btn" (click)="getAllInventory()">
          Get All Vehicles
        </button>
      </div>
    </div>

    <section class="data-table-container">
      <div class="table-responsive">
        <table class="data-table mx-auto w-100" data-testid="vehicle-lookup-table">
          <tr>
            <th class="selectable" style="min-width: 85px;width: auto;" [ngClass]="{ 'selected': isActiveSort('stockNumber') }"
                (click)="onSelectSort('stockNumber')">
              <div class="d-flex align-items-center">Stock #
                <i *ngIf="isActiveSort('stockNumber')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="width: 55px;" [ngClass]="{ 'selected': isActiveSort('year') }"
                (click)="onSelectSort('year')">
              <div class="d-flex align-items-center">Year
                <i *ngIf="isActiveSort('year')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 115px;" [ngClass]="{ 'selected': isActiveSort('make') }"
                (click)="onSelectSort('make')">
              <div class="d-flex align-items-center">Make
                <i *ngIf="isActiveSort('make')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 150px;" [ngClass]="{ 'selected': isActiveSort('model') }"
                (click)="onSelectSort('model')">
              <div class="d-flex align-items-center">Model<i *ngIf="isActiveSort('model')"
                                                             class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 150px;" [ngClass]="{ 'selected': isActiveSort('trim') }"
                (click)="onSelectSort('trim')">
              <div class="d-flex align-items-center">Trim
                <i *ngIf="isActiveSort('trim')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 80px" [ngClass]="{ 'selected': isActiveSort('type') }"
                (click)="onSelectSort('type')">
              <div class="d-flex align-items-center">Condition
                <i *ngIf="isActiveSort('type')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 70px;" [ngClass]="{ 'selected': isActiveSort('odometer') }"
                (click)="onSelectSort('odometer')">
              <div class="d-flex align-items-center">Mileage
                <i *ngIf="isActiveSort('odometer')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 80px;" [ngClass]="{ 'selected': isActiveSort('retail') }"
                (click)="onSelectSort('retail')">
              <div class="d-flex align-items-center">Retail
                <i *ngIf="isActiveSort('retail')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 85px" [ngClass]="{ 'selected': isActiveSort('bodyStyle') }"
                (click)="onSelectSort('bodyStyle')">
              <div class="d-flex align-items-center">Body
                <i *ngIf="isActiveSort('bodyStyle')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 300px;" [ngClass]="{ 'selected': isActiveSort('transmission') }"
                (click)="onSelectSort('transmission')">
              <div class="d-flex align-items-center">Transmission
                <i *ngIf="isActiveSort('transmission')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

            <th class="selectable" style="min-width: 140px" [ngClass]="{ 'selected': isActiveSort('lot') }"
                (click)="onSelectSort('lot')">
              <div class="d-flex align-items-center">Lot
                <i *ngIf="isActiveSort('lot')"
                   class="material-icons">{{ ascending ? 'arrow_drop_down' : 'arrow_drop_up' }}</i>
              </div>
            </th>

          </tr>

          <ng-container *ngIf="(vehicles || []).length">
            <tr
              *ngFor="let vehicle of vehiclesList | vehicleSort: sortParam : ascending; let i = index"
              class="selectable"
              [attr.data-testid]="'vehicle-lookup-row-' + (vehicle.stockNumber || ('unknown-' + i))"
              (click)="onSelectVehicle(vehicle)"
            >
              <td class="table-element">{{ vehicle.stockNumber }}</td>
              <td class="table-element">{{ vehicle.year }}</td>
              <td class="table-element">{{ vehicle.make ? vehicle.make.toUpperCase() : "" }}</td>
              <td class="table-element">{{ vehicle.model }}</td>
              <td class="table-element">{{ vehicle.trim }}</td>
              <td class="table-element">{{ vehicle.condition }}</td>
              <td class="table-element">{{ numberWithCommas(vehicle.odometer) }}</td>
              <td class="table-element">${{ numberWithCommas(vehicle.retail) }}</td>
              <td class="table-element">{{ vehicle.bodyStyle }}</td>
              <td class="table-element">{{ truncateString(vehicle.transmission) }}</td>
              <td class="table-element">{{ vehicle.lot }}</td>
            </tr>
          </ng-container>
        </table>
      </div>
    </section>
  </section>

</app-modal-view>
